import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
// import translations from '../../../constants/translations';
import Experience from '.';
/* eslint-disable */
/**
 * Header Provider HOC
 */
export default ({ locale, pageUri }) => (
  <StaticQuery
    query={graphql`
      query {
        allStrapiExperiencearticles {
          edges {
            node {
              key: id
              id
              title_es
              review_es
              content_es
              title_en
              review_en
              content_en
              slug
              image {
                childImageSharp {
                  fluid(maxWidth: 800, quality: 80) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      return (
        <Experience locale={locale} pageUri={pageUri} articles={data} />
      );
    }}
  />
);
